import {DcIconStruct} from '@shared-types';

import {UserType} from './user-type.types';

export const UserIconType: {[key in UserType]: string} = {
	[UserType.Sms]: 'fa-duotone fa-comment-sms fa-xl mx-1 icon-black-blue',
	[UserType.Whatsapp]: `fa-brands fa-whatsapp fa-xl mx-1 icon-green`,
	[UserType.Email]: `fa-duotone fa-at fa-xl mx-1 icon-blue`,
	[UserType.Qr]: `fa-duotone fa-qrcode fa-xl mx-1 icon-black`,
	[UserType.Registered]: `fa-duotone fa-user fa-xl mx-1 icon-blue`,
} as const;
/* -------------------------------------------------------------------------- */
/*                                 NEW VERSION                                */
/* -------------------------------------------------------------------------- */

export const UserTypeIcon: {
	[key in UserType]: DcIconStruct;
} = {
	[UserType.Sms]: {
		name: 'comment-sms',
		type: 'duotone',
		size: 'xl',
		color: 'primary',
	},
	[UserType.Whatsapp]: {
		name: 'whatsapp',
		type: 'brands',
		size: 'xl',
		color: 'success',
	},
	[UserType.Email]: {
		name: 'at',
		type: 'duotone',
		size: 'xl',
		color: 'primary',
	},
	[UserType.Qr]: {
		name: 'qrcode',
		type: 'duotone',
		size: 'xl',
		color: 'primary',
	},
	[UserType.Registered]: {
		name: 'user',
		type: 'duotone',
		size: 'xl',
		color: 'primary',
	},
};
